<section class="product-inventory-section" *ngIf="!disableFields"
         [formGroup]="inventoryForm">
  <div class="container-title">
    {{ 'text_inventory' | dbText }}
  </div>
  <div class="stock-status-container" *ngIf="!inventoryForm?.get('track_quantity')?.value; else backorderSection">
    <div class="field-label">
      {{ 'text_stockStatus' | dbText }}
    </div>
    <ds-dropdown [formControl]="statusFormControl"
                 [dsDropdownDisabled]="disableFields"
                 [dsDropdownOptions]="statusOptions">
    </ds-dropdown>
  </div>
  <div class="track-stock-container">
    <input type="checkbox"
           [disabled]="disableFields"
           formControlName="track_quantity" class="ds-checkbox" id="track-stock">
    <label for="track-stock" class="ds-checkbox-label black">
      {{ 'text_trackStockQuantityForThisProduct' | dbText }}
    </label>
    <i class="db-icon db-icon-ds-info-bg"
       [dsTooltip]="'text_productsStockAmount'|dbText"
       dsTooltipPosition="right"
       dsTooltipColor="black"
       dsTooltipAlign="top"></i>
  </div>
  <ng-template #backorderSection>
    <div class="backorder-form-container">
      <div class="field-container">
        <div class="field-label">
          {{ 'text_allowBackorders' | dbText }}
        </div>
        <ds-dropdown [formControl]="backorderStatusFormControl"
                     [dsDropdownDisabled]="disableFields"
                     [dsDropdownOptions]="backorderStatusOptions">
        </ds-dropdown>
      </div>

      <div class="field-container">
        <div class="field-label">
          {{ 'text_quantity' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               [class.disabled]="disableFields"
               placeholder="0"
               formControlName="quantity">
      </div>
    </div>
  </ng-template>
  <div class="product-options-container">
    <div class="product-options-title">
      <div class="container-title">
        {{ 'text_productOptions' | dbText }}
      </div>
      <span>
        <i class="db-icon db-icon-ds-info-bg"
           [dsTooltip]="'text_addProductShortDesc'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top"></i>
      </span>
    </div>

    <div class="product-options-body">
      <div class="product-options-desc" [innerHTML]="'text_sellDifferentVariations' | dbText">
      </div>
      <div class="product-options-action">
        <button class="ds-btn-s ds-btn-purple-blue" (click)="openAddOption()">{{ 'text_addProductOption' | dbText }}</button>
      </div>
    </div>
  </div>
</section>
